// Single place that maps the page's hostname to the TechTarget service tiers/hosts divesite
// talks to (ClickTrack activity pixel, smartforms registration gate), so every consumer
// agrees on which environment it's in.
//
// Environment:
//  - 'prod': Django says this is production (window.techtargetContext.isProd, rendered by
//            templates/snippets/techtarget_context.html). If the context isn't on the page,
//            falls back to an exact match against PROD_HOSTNAMES.
//  - 'qa':   qa. and staging. hosts (the hostname's first label, whatever the domain)
//  - 'eng':  everything else (local dev, eng., qaNN., ...)

// Exact production hostnames; anything not listed is never treated as prod.
const PROD_HOSTNAMES = [
  'techtarget.com',
  'www.techtarget.com',
  // TODO: Remove once we migrate to techtarget.com
  'techtargetdive.com',
  'www.techtargetdive.com',
];

const isProduction = (hostname) => {
  const isProd = window.techtargetContext?.isProd;
  return typeof isProd === 'boolean' ? isProd : PROD_HOSTNAMES.includes(hostname);
};

const resolveTechtargetEnvironment = (hostname) => {
  if (isProduction(hostname)) return 'prod';
  const [label] = hostname.split('.');
  if (label === 'qa' || label === 'staging') return 'qa';
  return 'eng';
};

// The page's own domain, so hosts keep working when the site moves from techtargetdive.com
// to techtarget.com.
// TODO: Remove this once we migrate to techtarget.com
const resolveTechtargetDomain = (hostname) => {
  if (hostname === 'techtargetdive.com' || hostname.endsWith('.techtargetdive.com')) {
    return 'techtargetdive.com';
  }
  return 'techtarget.com';
};

// eng/qa hosts carry the environment name; production hosts carry none.
const clicktrackBaseUrl = (hostname = window.location.hostname) => {
  const env = resolveTechtargetEnvironment(hostname);
  return env === 'prod' ? 'https://go.techtarget.com' : `https://go-${env}.techtarget.com`;
};

// Smartforms lives on the page's own domain (see resolveTechtargetDomain).
const smartFormsBaseUrl = (hostname = window.location.hostname) => {
  const env = resolveTechtargetEnvironment(hostname);
  const domain = resolveTechtargetDomain(hostname);
  return env === 'prod' ? `https://users.${domain}` : `https://users.${env}.${domain}`;
};

export {
  resolveTechtargetEnvironment, clicktrackBaseUrl, smartFormsBaseUrl,
};
